import { FC, ReactElement, useEffect, useState } from 'react'
import { Backdrop, Box, CircularProgress } from '@mui/material'
import { StateType } from '../../redux/store'
import { connect } from 'react-redux'
import { actions as appActions } from '../../redux/appReducer'
import { Loader } from 'three'

interface IProps {
  children: ReactElement
  isSuperAdmin: boolean
  isDataFetched: boolean
  isMaterialsFetched: boolean
  setActiveTab(value: number): void
}

const AdminTabsWrapper: FC<IProps> = (props) => {
  const [isFetched, setIsFetched] = useState(
    props.isDataFetched && props.isMaterialsFetched
  )

  useEffect(() => {
    setIsFetched(props.isDataFetched && props.isMaterialsFetched)
  }, [(props.isDataFetched, props.isMaterialsFetched)])

  useEffect(() => {
    if (!props.isSuperAdmin) {
      props.setActiveTab(0)
    }
  }, [props.isSuperAdmin])

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={!isFetched}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {isFetched && props.children}
    </>
  )
}

const mapStateToProps = (state: StateType) => ({
  isSuperAdmin: state.appReducer.isSuperAdmin,
  isDataFetched: state.appReducer.isDataFetched,
  isMaterialsFetched: state.itemReducer.isMaterialsFetched,
})

export default connect(mapStateToProps, {
  setActiveTab: appActions.setActiveTab,
})(AdminTabsWrapper)
